<template>
    <auth-layout>
        <div class="auth-form-container">
            <jet-validation-errors class="mb-4" />

            <h3>Reimposta la password</h3>
            <p>Crea una nuova password</p>

            <form @submit.prevent="submit" class="mt-5">
                <div class="auth-form-group">
                    <jet-input id="email" type="email" placeholder="Email" class="mt-1 auth-form-control block w-full" v-model="form.email" required autofocus />
                </div>

                <div class="auth-form-group">
                    <jet-input id="password" type="password" class="mt-1 auth-form-control block w-full" placeholder="Nuova password" v-model="form.password" required autocomplete="new-password" />
                </div>

                <div class="auth-form-group">
                    <jet-input id="password_confirmation" type="password" placeholder="Ripeti password" class="mt-1 auth-form-control block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
                </div>

                <div class="auth-form-group">
                    <button type="submit" class="btn btn-primary" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">Crea</button>
                </div>
            </form>

            <div v-if="status" class="alert alert-success mt-4">
                <p class="mb-0">Password creata correttamente</p>
            </div>                   
        </div>
    </auth-layout>
</template>

<script>
    import AuthLayout from '@/Layouts/AuthLayout'
    import JetButton from '@/Jetstream/Button'
    import JetInput from '@/Jetstream/Input'
    import JetLabel from '@/Jetstream/Label'
    import JetValidationErrors from '@/Jetstream/ValidationErrors'

    export default {
        components: {
            AuthLayout,
            JetButton,
            JetInput,
            JetLabel,
            JetValidationErrors
        },

        props: {
            email: String,
            token: String,
        },

        data() {
            return {
                form: this.$inertia.form({
                    token: this.token,
                    email: this.email,
                    password: '',
                    password_confirmation: '',
                })
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('password.update'), {
                    onFinish: () => this.form.reset('password', 'password_confirmation'),
                })
            }
        }
    }
</script>
